const gridOverlay = document.querySelector(".grid-overlay");

if (gridOverlay) {
    let showGrid = window.localStorage.getItem("showGrid");
    let applyGrid = function() {
        if (showGrid) {
            gridOverlay.classList.add("grid-overlay--active");
            window.localStorage.setItem("showGrid", "true");
        } else {
            gridOverlay.classList.remove("grid-overlay--active");
            window.localStorage.removeItem("showGrid");
        }
    };
    document.addEventListener("keyup", (evt) => {
        if (evt.ctrlKey && evt.which == 71) {
            showGrid = !showGrid;
            applyGrid();
        }
    });
    applyGrid();
}
